<ngx-gauge type="full"
           [size]="56"
           [value]="progress"
           append="%"
           foregroundColor="#bb171a"
           backgroundColor="#d8dfec">
</ngx-gauge>